// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"377c77d6","377":"377c77d6","561":"377c77d6","786":"377c77d6","865":"377c77d6","898":"377c77d6","925":"1ab56c98"}[chunkId] + ".css";
};